module.exports = __webpack_public_path__ + "img/header.92dd8a8f.png";